const NS = 'canopy';
export function get<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(`${NS}:${key}`);
    return raw ? JSON.parse(raw) as T : fallback;
  } catch { return fallback; }
}
export function set<T>(key: string, value: T) {
  localStorage.setItem(`${NS}:${key}`, JSON.stringify(value));
}
export function del(key: string) {
  localStorage.removeItem(`${NS}:${key}`);
}
